export default [
    {
        path: 'listagem-consulta-agendada-realizada',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-listagem-consulta-agendada-realizada' */
            '@/views/ambulatorio/listagem-consulta-agendada-realizada/Index'
        ),
        redirect: 'listagem-consulta-agendada-realizada/index',
        children: [
            {
                name: 'ambulatorio-listagem-consulta-agendada-realizada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-listagem-consulta-agendada-realizada' */
                    '@/views/ambulatorio/listagem-consulta-agendada-realizada/List.vue'
                ),
            },
        ],
    },
]